import React, { Component } from "react";
import { Checkbox } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import {
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    Paper,
    TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
    padding: 0,  // Equivalent to adding class p-0
}));

class RoleListViewTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasVerticalScrollbar: false,
        };
        this.tableRef = React.createRef();
        this.scrollTimeout = null;
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        this.tableRef.current.addEventListener("scroll", this.handleScroll);
    }

    handleScroll() {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            const table = this.tableRef.current;
            // 
            // const { filters } = this.state;
            if (
                this.tableRef.current.scrollTop + this.tableRef.current.clientHeight >=
                table.scrollHeight - 50
            ) {
                this.props.handleScroll();
            }
        }, 200);
    }
    componentDidUpdate() {
        if (this.tableRef.current) {
            const element = this.tableRef.current;
            const hasVerticalScrollbar = element.scrollHeight > element.clientHeight;
            if (this.state.hasVerticalScrollbar !== hasVerticalScrollbar) {
                this.setState({ hasVerticalScrollbar });
            }
        }
    }

    handleCheckboxChange = (event, roleId, userId) => {
        this.props.onCheckboxChange(event, roleId, userId);
    };

    isUserSelected = (roleId, userId) => {
        return this.props.isCheckBoxChecked(roleId, userId);
    };

    render() {
        const columnHeaders = this.props?.columns;
        const sortConfig = this.props?.sortConfig;
        const normalData = this.props?.value || [];
        const isLoader = this.props?.isLoader;

        return (
            <TableContainer
                component={Paper}
                className={`role-table_change removeborder plr mr-scroll-1 px-4 mt-0 mb-0`}
                sx={{ marginTop: 2 }}
                ref={this.tableRef}
            >
                <Table
                    className={`tableborder table-wid-2 ${this.state.hasVerticalScrollbar ? "normalwidth" : "scrolerwidth"
                        }`}
                    stickyHeader
                    aria-label="sticky table"
                >
                    <TableHead
                        sx={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                            "& .MuiTableCell-root": { backgroundColor: "background.paper" },
                        }}
                    >
                        <TableRow className="tabel-head">
                            {columnHeaders.map((column) => (
                                <TableCell
                                    className="table-header-padding"
                                    key={column.key}
                                    size="small"
                                >
                                    {column.key === "checkbox" ? (
                                        <CustomCheckbox disabled />
                                    ) : (
                                        <TableSortLabel
                                            className="table_label"
                                            active={sortConfig.sortBy === column.key}
                                            // sx={{ width: "20%" }}
                                            direction={sortConfig.sortByOrder}
                                            onClick={() => this.props?.handleUserSort(column.key)}
                                        >
                                            <span style={{ color: "#123763" }}>{column.label}</span>
                                        </TableSortLabel>
                                    )}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {normalData.length > 0 ? (
                            <>
                                {normalData.map((row) => (
                                    row.users.map((user, index) => ( // Iterate through each user in roles
                                        <TableRow key={index}> {/* Use a unique key for each row */}
                                            {columnHeaders.map((column) => (
                                                <TableCell
                                                    className="table-cell-padding"
                                                    key={`${column.key}-${index}`} // Use a unique key for each cell
                                                >
                                                    {column.key === "checkbox" ? (
                                                        <CustomCheckbox
                                                            // checked={row.checked || false}
                                                            checked={this.isUserSelected(row.roleId, user.id)}
                                                            onChange={(event) => {
                                                                console.log("Checkbox Changed - roleId:", row.roleId, "userId:", user.id);
                                                                this.handleCheckboxChange(event, row.roleId, user.id);
                                                            }}
                                                        />
                                                    ) : column.key === "name" ? ( // Render user's name
                                                        user.name
                                                    ) : column.key === "email" ? ( // Render user's email
                                                        user.email
                                                    ) : (
                                                        "-" // Render "-" for other columns or handle as needed
                                                    )}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ))}

                                {isLoader && (
                                    <TableRow className="border-no">
                                        <TableCell
                                            colSpan={columnHeaders.length + 1}
                                            className="group-header mt-3 text-center"
                                            align="center"
                                        >
                                            <CircularProgress
                                                color="primary"
                                                className="text-center"
                                            />
                                        </TableCell>
                                    </TableRow>
                                )}
                            </>
                        ) : normalData.length === 1 || isLoader ? (
                            <TableRow>
                                <TableCell
                                    colSpan={columnHeaders.length + 1}
                                    className="group-header mt-3 text-center"
                                    align="center"
                                >
                                    <CircularProgress color="primary" className="text-center" />
                                </TableCell>
                            </TableRow>
                        ) : (
                            <TableRow className="border-no">
                                <TableCell
                                    colSpan={columnHeaders.length + 1}
                                    className="group-header mt-3 text-center"
                                    align="center"
                                >
                                    No records to display
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            // </Paper>
        );
    }
}

// export function handleCheckboxChange(event, id, onCheckboxChange) {
//     const isChecked = event.target.checked;
//     if (onCheckboxChange) {
//         onCheckboxChange(id, isChecked);
//     }
// }

export default RoleListViewTable;
